export default __webpack_public_path__ + "static/media/full1.02aef548.jpg";